import { render, staticRenderFns } from "./EditUserAvatar.vue?vue&type=template&id=62a8534f&scoped=true"
import script from "./EditUserAvatar.vue?vue&type=script&lang=ts"
export * from "./EditUserAvatar.vue?vue&type=script&lang=ts"
import style0 from "./EditUserAvatar.vue?vue&type=style&index=0&id=62a8534f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8534f",
  null
  
)

export default component.exports